export default function loadCSS(url) {
  const link = document.createElement('link');
  link.setAttribute('type', 'text/css');
  link.setAttribute('rel', 'stylesheet');
  link.setAttribute('href', url);
  document.head.appendChild(link);
}



// WEBPACK FOOTER //
// ./src/util/loadcss.js